module.exports = __webpack_public_path__ + "img/TierTwoAlternatives_01_BRT.e5785fa4.jpg";